// Node Modules
import { RichText } from 'prismic-reactjs';

// Themes
import theme from '@/themes/index';

const Reason = ({
  content: {
    title,
    description, 
  }, 
}) => (
  <>
    <div className='reason-container'>
      <div className='content'>
        <h6>{title}</h6>
        <RichText render={description} />
      </div>
    </div>
    <style jsx>{`
      .reason-container {
        justify-content: center;
        display: flex;
        flex-direction: row;
        min-height: 7.5rem;
        text-align: center;
        max-width: 21.188rem;
      }
      .reason-container .content {
        padding-top: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .reason-container .content h6 {
        color: ${theme.fontColors.optional5}; 
        font-family: ${theme.fontFamilies.montserratBold};
        padding-bottom: 1rem;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0;
        margin-inline-end: 0;
      }
      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        .reason-container {
          width: 34rem;
        }
      }
    `}</style>
    <style global jsx>{`
      div.reason-container .content p {
        line-height: 1.5rem;
        font-size: 0.875rem;
        margin: 0rem 3rem;
        text-align: center;
      }
    `}</style>
  </>
);

export default Reason;
